import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PublicThemeContext } from '../hooks/publicThemeContext';
import { PublicAnalytics } from './PublicAnalytics';

export function PublicLayout() {
    useLayoutEffect(() => {
        document.documentElement.dataset.publicTheme = 'light';
        return () => { delete document.documentElement.dataset.publicTheme; };
    }, []);

    return <PublicThemeContext.Provider value={true}><PublicAnalytics /><Outlet /></PublicThemeContext.Provider>;
}
